export default __webpack_public_path__ + "static/press_1_orig-0f33e7eed6cc4152c544fefcadf345d3.jpg";